import { useEffect } from 'react';
import { toast, ToastContainer } from 'react-toastify';
import { useData } from '../state/services';


export default function ErrorToast () {
    const { errors } = useData()
    useEffect(() => {
        if (errors) {
          // Show toast message when there's an error
           toast.error(errors.message?  <div dangerouslySetInnerHTML={{ __html: errors.message }} /> : 'Something went wrong!',{ autoClose: 8000});
        }
      }, [errors]);
      return <>
            <ToastContainer />
      </>
}